import { useEffect } from 'react';

import { useConfigStore, useRegionStore } from '@packages/stores';

import { captureException } from '@sentry/react';

import { WebConfigSchema } from '../../scripts/remoteConfigSchema';

export const useGetConfig = () => {
  const getConfig = useConfigStore(state => state.getConfig);
  const setRegionSpecificConfig = useConfigStore(state => state.setRegionSpecificConfig);
  const country = useRegionStore(state => state?.region?.country);
  useEffect(() => {
    getConfig()
      .then(config => {
        if (country) setRegionSpecificConfig({ country: country });
        const webConfigResult = WebConfigSchema.safeParse(config);
        if (!webConfigResult.success) {
          captureException(new Error('AppConfig failed validation'), {
            tags: {
              source: 'useGetConfig/getConfig',
            },
            extra: {
              validationError: webConfigResult.error.format(),
            },
          });
        }
        return;
      })
      .catch(error => {
        captureException(new Error('AppConfig failed to fetch'), {
          tags: {
            source: 'useGetConfig/getConfig',
          },
          extra: {
            error,
          },
        });
      });
  }, [getConfig, setRegionSpecificConfig, country]);
};
